import { render } from "./fc.vue?vue&type=template&id=1504b750"
import script from "./fc.vue?vue&type=script&lang=js"
export * from "./fc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__